// extracted by mini-css-extract-plugin
export default {"Slot":"Slot_Slot__0hXg5","FullWidth":"Slot_FullWidth__MgXIl","HalfWidth":"Slot_HalfWidth__3VT8I","ThirdWidth":"Slot_ThirdWidth__upedm","QuarterWidth":"Slot_QuarterWidth__OSV++"};